module.exports = __webpack_public_path__ + "71ebca0fc20309fd3eb8a49ab5105a2f.jpg";